import React from 'react';

const CorsInfo = () => {
  return (
    <div className="text-xs text-gray-500 bg-yellow-50 p-2 rounded mt-2">
      <strong>Note:</strong> Audio could not be loaded. Try playing again.
      If it keeps failing, the file may be missing or the signed URL may have expired.
    </div>
  );
};

export default CorsInfo;
